export default __webpack_public_path__ + "static/media/Millets.e1f66d35.jpg";